var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFcCarLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6667 12.6667V14C10.6667 14.368 10.9653 14.6667 11.3333 14.6667H14C14.368 14.6667 14.6667 14.368 14.6667 14V12.6667H10.6667Z",
    fill: "var(--fill-0, #86B4F9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.666667 12H15.3333C15.7013 12 16 11.7013 16 11.3333V7.33333C16 7.15667 15.93 6.98667 15.8047 6.862L14.602 5.65933L13.3133 0.504667C13.2393 0.208 12.9727 0 12.6667 0H3.33333C3.02733 0 2.76067 0.208 2.68667 0.504667L1.398 5.65933L0.195333 6.862C0.07 6.98667 0 7.15667 0 7.33333V11.3333C0 11.7013 0.298667 12 0.666667 12ZM13.3333 9C13.3333 9.552 12.8853 10 12.3333 10C11.7813 10 11.3333 9.552 11.3333 9C11.3333 8.448 11.7813 8 12.3333 8C12.8853 8 13.3333 8.448 13.3333 9ZM3.854 1.33333H12.146L13.146 5.33333H2.854L3.854 1.33333ZM3.66667 8C4.21867 8 4.66667 8.448 4.66667 9C4.66667 9.552 4.21867 10 3.66667 10C3.11467 10 2.66667 9.552 2.66667 9C2.66667 8.448 3.11467 8 3.66667 8Z",
    fill: "var(--fill-0, #86B4F9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.33333 12.6667V14C1.33333 14.368 1.632 14.6667 2 14.6667H4.66667C5.03467 14.6667 5.33333 14.368 5.33333 14V12.6667H1.33333Z",
    fill: "var(--fill-0, #86B4F9)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcCarLoan);
export default __webpack_public_path__ + "static/media/fc-car-loan.064103f0b815df61ed95ca2444762c7e.svg";
export { ForwardRef as ReactComponent };